"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var margin_1 = __importDefault(require("../Utils/margin"));
var padding_1 = __importDefault(require("../Utils/padding"));
var useOutsideClick_1 = __importDefault(require("../Hooks/useOutsideClick"));
var useWindowSize_1 = require("../Hooks/useWindowSize");
var react_1 = require("react");
var PopupWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  display: inline-block;\n  position: relative;\n"], ["\n  ", "\n  ", "\n  display: inline-block;\n  position: relative;\n"])), margin_1.default, padding_1.default);
var PopupContents = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  z-index: 3;\n"], ["\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  z-index: 3;\n"])), function (props) { return props.$above && "top: 0;"; }, function (props) { return props.$align === 'right' && "right: 0;"; }, function (props) { return props.$align === 'center' && "left: 50%;"; }, function (props) { return props.$wrapperRect && "left: -".concat(props.$wrapperRect.left, "px; width: 100vw;"); }, function (props) { return props.$transform && "transform: ".concat(props.$transform, ";"); });
var PopupManager = function (_a, ref) {
    var above = _a.above, align = _a.align, children = _a.children, element = _a.element, fullWidth = _a.fullWidth, onHover = _a.onHover, open = _a.open, props = __rest(_a, ["above", "align", "children", "element", "fullWidth", "onHover", "open"]);
    var _b = React.useState(open || false), show = _b[0], setShow = _b[1];
    var _c = React.useState(), elemRect = _c[0], setElemRect = _c[1];
    var size = (0, useWindowSize_1.useWindowSize)();
    var clickRef = (0, useOutsideClick_1.default)(function () {
        if (!onHover && show) {
            setShow(false);
        }
    });
    var onClose = (0, react_1.useCallback)(function () {
        setShow(false);
    }, []);
    React.useImperativeHandle(ref, function () { return ({
        setShow: function (value) { return setShow(value !== undefined ? value : !show); },
    }); });
    React.useEffect(function () {
        var _a;
        if (clickRef.current && fullWidth) {
            setElemRect((_a = clickRef === null || clickRef === void 0 ? void 0 : clickRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect());
        }
        else {
            setElemRect(undefined);
        }
        return function () { return setElemRect(undefined); };
    }, [clickRef, fullWidth, size]);
    var horizontal = align === 'center' ? '-50%' : '0';
    var vertical = above ? '-100%' : '0';
    var transform = elemRect ? 'none' : "translate(".concat(horizontal, ", ").concat(vertical, ")");
    return (React.createElement(PopupWrapper, __assign({}, props, (onHover && {
        onMouseLeave: function () { return setShow(open ? open : false); },
        onMouseEnter: function () { return setShow(open ? open : true); },
    }), { ref: clickRef }),
        React.createElement("div", __assign({}, (!onHover && { onClick: function () { return setShow(!show); } })), element(show)),
        show && (React.createElement(PopupContents, { "$align": align, "$above": above, "$transform": transform, "$wrapperRect": elemRect }, children(onClose)))));
};
exports.default = React.forwardRef(PopupManager);
var templateObject_1, templateObject_2;
